import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../../services/user.service';
import { MetadataQuickViewComponent } from '../../../views/metadata-quick-view/metadata-quick-view.component';

/**
 * Component for viewing workflow task properties.
 */
@Component({
	selector: 'workflow-task-properties',
	templateUrl: './task-properties.component.html',
	styleUrl: './task-properties.component.css'
})
export class TaskPropertiesComponent implements OnInit {
	@Input() task: any;

	LOCALIZATION: any;

	constructor(
		private modalService: NgbActiveModal,
		private ngbModal: NgbModal,
		private userService: UserService,
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
	}

	/**
	 * Displays the full metadata for the task product.
	 */
	viewProductMetadata(): void {
		const modalRef = this.ngbModal.open(MetadataQuickViewComponent);
		modalRef.componentInstance.productId = this.task.productUUID;

		modalRef.result.then(
			(payload) => {
				console.log('Modal dismissed');
			},
			(reason) => {
				console.log('Modal dismissed');
			}
		);
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.modalService.dismiss();
	}
}